module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/background.cd2f1bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/background.jpg
// module id = r1d7
// module chunks = 1